import { useState } from 'react';

const {
  cookieConsentEnabled,
  cookieConsentOriginTrialToken,
} = window.mobile.features.cookieManagementSettings;

/* eslint-disable react/prop-types */
const Cookies = ({ user }) => {
  const [headerAdded, setHeaderAdded] = useState(false);

  if (!headerAdded && cookieConsentEnabled && user && user.isAuthenticated) {
    const preload1 = document.createElement('script');
    const preload2 = document.createElement('script');
    const meta = document.createElement('meta');
    const script = document.createElement('script');

    preload1.setAttribute('src', 'https://consent.trustarc.com/autoblockasset/core.min.js?domain=prsformusic.com');
    preload2.setAttribute('src', 'https://consent.trustarc.com/autoblockoptout?domain=prsformusic.com');
    meta.setAttribute('http-equiv', 'origin-trial');
    meta.setAttribute('content', cookieConsentOriginTrialToken);
    script.setAttribute('src', 'https://consent.trustarc.com/notice?domain=prsformusic.com&gtm=1&c=teconsent&js=nj&noticeType=bb&text=true&pcookie');
    script.setAttribute('crossorigin', '');

    document.head.appendChild(preload1);
    document.head.appendChild(preload2);
    document.head.appendChild(meta);
    document.head.appendChild(script);

    setHeaderAdded(true);
  }

  return (null);
};

export default Cookies;
